import type { VoidFunctionComponent } from 'react';

import DynamicShowMoreList from '../../../../../../generic/DynamicShowMoreList';
import type { Dependency } from '../../../../../../../../shared/dependenciesV2';

import { buildRichLicense, ConcludedLicensingBadge, unconcludedRichLicense, unlicensedRichLicense } from './shared';

import styles from '../DetailsRow.module.less';

type Props = {
  // License IDs for the dependency
  licenses: string[];
  // Declared licenses for the dependency
  declaredLicenses: string[];
  // Concluded licenses for the dependency
  concludedLicenses: string[];
  // Issues on the dependency
  issues: Dependency['issues'];
};

/**
 * License section containing a list of licenses
 * @returns License section
 */
const ConcludedLicensingSection: VoidFunctionComponent<Props> = ({
  licenses,
  declaredLicenses,
  concludedLicenses,
  issues,
}) => {
  const declaredCount = declaredLicenses.length;
  const discoveredCount = licenses.length - declaredCount;

  const richLicenses = concludedLicenses
    .map((license) => buildRichLicense(license, declaredLicenses, issues));

  // If there are no licenses at all, show the unlicensed license badge.
  if (licenses.length === 0) {
    richLicenses.push(unlicensedRichLicense);
  }

  if (richLicenses.length === 0) {
    richLicenses.push(unconcludedRichLicense);
  }

  const licenseElements = richLicenses.map((richLicense) => {
    return <ConcludedLicensingBadge license={richLicense} key={richLicense.licenseId} />;
  });

  return (
    <div className={styles.licenseList}>
      <DynamicShowMoreList list={licenseElements} lineHeight={27} />
      <div>
        {declaredCount} declared, {discoveredCount} discovered
      </div>
    </div>
  );
};

export default ConcludedLicensingSection;
